<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;

  }

  .page {
    margin: 0;
    height: 100%;
  }

  .page > div {
    width: 1200px;
  }

  .pageMax{
    margin: 0;
    height: 100%;
  }
  .pageMax > div {
    width: 1200px;
  }

  .el-carousel__item img {
    width: 100%;
    height: 100%;
  }

  .page-list {
    width: 85%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 30px 0px;
    padding-bottom: 20px;
    user-select: none;
  }

  .page-list-title {
    user-select: none;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    padding: 20px 0px;
    /* border-bottom: #b0b2b6 solid 2px;*/
    color: red;
    font-weight: 600;
    letter-spacing: 3px;
  }

  .page-tabs {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .page-tabs .el-tabs__header {
    width: 100%;
  }

  .page-tabs .el-tabs__item {
    font-size: 17px;
  }

  .page .img img {
    width: 100%;
    height: 100%;
  }

  .page .img{
    width: 1200px;
    height: 380px;
  }

  .top .el-submenu__title{
    border-bottom: solid 0px #e6e6e6 !important;
    border-bottom-color: white  !important;
  }
  .top .el-menu-item.is-active {  border-bottom: solid 0px #e6e6e6  !important; }

</style>

<style>

  .new-list-title > div {
    margin: 0px 10px;
    font-size: 23px;
  }

  .new-list-details {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0px 0px 0px 0px;
    padding-bottom: 20px;

  }

  .new-list-details > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-bottom: #d4d4d4 solid 1px;
    padding: 30px 0px;
  }

  .new-list-details-date {
    width: 200px;
    margin-right: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-right: #d4d4d4 solid 1px;
  }

  .new-list-details-date > div {
    margin: 0px 5px;
    font-weight: 600;
  }

  .new-list-details-date > div:nth-child(1) {
    font-size: 30px;
  }

  .new-list-details-content {
    width: calc(100% - 200px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
   }

  .new-list-details-content > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    /* overflow:hidden;*/
    text-align: left;
  }

  .new-list-details-content > div:nth-child(1) {
    font-weight: 600;
  }

  .new-list-details-content > div:nth-child(2) {
    display: block;
  }

  .new-list-page {
    margin: 30px 0px 100px 0px;
  }


</style>





// WEBPACK FOOTER //
// src/App.vue